// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module__card___UyawY","desktopOnly":"Card-module__desktopOnly___JiVyv"};